import { Link } from "react-router-dom";
import { MapPin, Mail, Globe, Linkedin, Youtube, Facebook, ArrowUpRight } from "lucide-react";
import { Logo } from "./Logo";
import { NAV, COMPANY } from "@/data/content";

export const Footer = () => {
  return (
    <footer
      className="relative overflow-hidden border-t border-steel/20 bg-aero-surface"
      data-testid="site-footer"
    >
      {/* Est. 1974 watermark */}
      <div className="pointer-events-none absolute -bottom-6 left-0 right-0 select-none text-center">
        <span className="font-heading text-[22vw] font-black leading-none tracking-tighter text-ink/[0.04] sm:text-[16vw]">
          EST. 1974
        </span>
      </div>

      <div className="relative mx-auto max-w-[1400px] px-5 py-16 sm:px-8 sm:py-20">
        <div className="grid gap-12 lg:grid-cols-[1.4fr_1fr_1fr]">
          <div>
            <Logo size="md" />
            <p className="mt-6 max-w-sm font-body text-sm leading-relaxed text-steel">
              {COMPANY.tagline}. Built with Indian hands, for Indian skies — from
              aeromodelling engines to indigenous defence RPAS.
            </p>
            <div className="mt-6 flex gap-3">
              {[Linkedin, Youtube, Facebook].map((Icon, i) => (
                <a
                  key={i}
                  href="#"
                  data-testid={`footer-social-${i}`}
                  className="grid h-10 w-10 place-items-center rounded-full border border-steel/30 text-steel transition-colors duration-300 hover:border-saffron hover:text-saffron"
                  aria-label="social link"
                >
                  <Icon className="h-4 w-4" />
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-xs uppercase tracking-[0.22em] text-saffron">
              Explore
            </h4>
            <ul className="mt-5 space-y-3">
              {NAV.map((item) => (
                <li key={item.to}>
                  <Link
                    to={item.to}
                    data-testid={`footer-link-${item.to.replace("/", "")}`}
                    className="group flex items-center gap-1.5 font-body text-sm text-steel transition-colors hover:text-ink"
                  >
                    {item.label}
                    <ArrowUpRight className="h-3.5 w-3.5 opacity-0 transition-all duration-300 group-hover:opacity-100" />
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-xs uppercase tracking-[0.22em] text-saffron">
              Get in Touch
            </h4>
            <ul className="mt-5 space-y-4 font-body text-sm text-steel">
              <li className="flex gap-3">
                <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-saffron" />
                <span>{COMPANY.address}</span>
              </li>
              <li className="flex gap-3">
                <Mail className="mt-0.5 h-4 w-4 shrink-0 text-saffron" />
                <a href={`mailto:${COMPANY.email}`} className="hover:text-ink" data-testid="footer-email">
                  {COMPANY.email}
                </a>
              </li>
              <li className="flex gap-3">
                <Globe className="mt-0.5 h-4 w-4 shrink-0 text-saffron" />
                <span>{COMPANY.website}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 flex flex-col items-start justify-between gap-4 border-t border-steel/20 pt-8 sm:flex-row sm:items-center">
          <p className="font-body text-xs text-steel">
            {COMPANY.name} | {COMPANY.location} | Est. {COMPANY.established}
          </p>
          <p className="font-body text-xs text-steel/70">
            © {new Date().getFullYear()} {COMPANY.shortName}. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};
